import { ColumnDefinitions } from '../column-configs';

export const chatBotColumnsWithTimeCondition = [
  ColumnDefinitions.Created,
  ColumnDefinitions.Started
];

export const chatQueueColumnsWithTimeCondition = [
  ColumnDefinitions.Created,
  ColumnDefinitions.Started
];

export const chatAssignedColumnsWithTimeCondition = [
  ColumnDefinitions.Created,
  ColumnDefinitions.Started,
  ColumnDefinitions.Answered
];

export const chatClosedColumnsWithTimeCondition = [
  ColumnDefinitions.Created,
  ColumnDefinitions.Started,
  ColumnDefinitions.Answered,
  ColumnDefinitions.Ended,
  ColumnDefinitions.Closed,
  ColumnDefinitions.WindowClosed,
  ColumnDefinitions.Updated
];

export const emailQueueColumnsWithTimeCondition = [
  ColumnDefinitions.Created,
  ColumnDefinitions.QueueTime,
  ColumnDefinitions.FirstIncomingArrived
];

export const emailAssignedColumnsWithTimeCondition = [
  ColumnDefinitions.Created,
  ColumnDefinitions.QueueTime,
  ColumnDefinitions.FirstIncomingArrived,
  ColumnDefinitions.Accepted,
  ColumnDefinitions.Opened,
  ColumnDefinitions.Answered,
  ColumnDefinitions.LastIncomingArrived,
  ColumnDefinitions.LastAssignedAnswered,
  ColumnDefinitions.Updated
];

export const emailClosedColumnsWithTimeCondition = [
  ColumnDefinitions.Created,
  ColumnDefinitions.QueueTime,
  ColumnDefinitions.FirstIncomingArrived,
  ColumnDefinitions.Accepted,
  ColumnDefinitions.Opened,
  ColumnDefinitions.Answered,
  ColumnDefinitions.LastIncomingArrived,
  ColumnDefinitions.LastAssignedAnswered,
  ColumnDefinitions.Closed,
  ColumnDefinitions.Updated
];

export const messagingQueueColumnsWithTimeCondition = [
  ColumnDefinitions.Created,
  ColumnDefinitions.Started,
  ColumnDefinitions.LastMessageSent
];

export const messagingAssignedColumnsWithTimeCondition = [
  ColumnDefinitions.Created,
  ColumnDefinitions.Started,
  ColumnDefinitions.Answered,
  ColumnDefinitions.LastMessageSent
];

export const messagingClosedColumnsWithTimeCondition = [
  ColumnDefinitions.Created,
  ColumnDefinitions.Started,
  ColumnDefinitions.Answered,
  ColumnDefinitions.Ended,
  ColumnDefinitions.Closed,
  ColumnDefinitions.LastMessageSent
];

export const messagingBotColumnsWithTimeCondition = [
  ColumnDefinitions.Created,
  ColumnDefinitions.Started,
  ColumnDefinitions.Answered,
  ColumnDefinitions.LastMessageSent
];
